import { createContext } from "react";

const webinarContext = createContext();

export default webinarContext;